import { Adressvorschlag } from '@ps20-frontend/frontend-models';
import {
  AdressvorschlagFailedPayload,
  AdressvorschlagPayload,
  CALLER_ID,
  GlobalActions,
} from '@ps20-frontend/shop-integration-redux';
import { AnyAction } from 'redux';
import { TkvActions } from '../tkvActions';

export const adressvorschlagReducer = function (
  sectionState: Adressvorschlag = null,
  action: AnyAction,
): Adressvorschlag {
  switch (action.type) {
    case GlobalActions.ADDRESSVORSCHLAG_SUCCESSFUL: {
      const payload: AdressvorschlagPayload = action.payload;
      if (payload.callerId !== CALLER_ID.TKV_BASISDATEN) {
        return sectionState;
      }
      return {
        lastError: null,
        orte: payload.orte,
        strassen: payload.strassen,
      };
    }

    case GlobalActions.ADDRESSVORSCHLAG_FAILED: {
      const payload: AdressvorschlagFailedPayload = action.payload;
      if (payload.callerId !== CALLER_ID.TKV_BASISDATEN) {
        return sectionState;
      }
      return {
        lastError: payload.reason,
        orte: [],
        strassen: [],
      };
    }

    case TkvActions.PLZ_CHANGED: {
      return {
        lastError: null,
        orte: [],
        strassen: [],
      };
    }

    default:
      return sectionState;
  }
};
